import { ExportToCsv, Options } from 'export-to-csv';

const defaultOptions: Options = {
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalSeparator: '.',
  showLabels: true,
  showTitle: false,
  useTextFile: false,
  useBom: true,
  useKeysAsHeaders: true,
};

export function generateAndDownloadCSV(title: string, data: any): void {
  const csvExporter = new ExportToCsv({
    ...defaultOptions,
    filename: title,
  });
  csvExporter.generateCsv(data);
}
